<template>
    <div>
        <h1 class="title">Créer un compte</h1>
        <div class="card white">
            <h2>Détails du compte</h2>
            <div class="form-group">
                <div class="form-control">
                    <label for="email">Email*</label>
                    <input type="email" id="email" v-model="email" required />
                </div>
                <div class="form-control">
                    <label>Est-il administrateur ?</label>
                    <input type="checkbox" id="type" v-model="type" style="display: none;" />
                    <label :class="{ 'button': true, 'outline': !type, 'fill': type, 'dotted': true, 'orange': true }"
                        for="type" style="transition: none;">
                        {{ type ? "Oui" : "Non" }}
                    </label>
                </div>
            </div>
            <div v-if="errorMessage" class="message">{{ errorMessage }}</div>
            <button type="submit" class="button fill normal" :disabled="isSubmitting" @click="submitForm">
                Ajouter
            </button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AjouterCompte',
    data() {
        return {
            email: "",
            type: false,
            errorMessage: "",
            isSubmitting: false,
        };
    },
    methods: {
        async submitForm() {
            if (!this.email) return this.errorMessage = " Veuillez saisir une adresse email valide.";

            try {
                this.isSubmitting = true;
                this.errorMessage = "";

                const body = JSON.stringify({ email: this.email, type: this.type });
                const response = await fetch(process.env.VUE_APP_API_URL + "franchise/account/add", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: 'include', body });

                if (response.ok) return this.errorMessage = "Compte créé, un email a été envoyé.";

                const errorData = await response.json();
                this.errorMessage = errorData.message || "Erreur lors de la soumission des données. Veuillez réessayer.";
            } catch (error) {
                console.error("Erreur lors de la soumission du formulaire:", error);
                this.errorMessage = "Erreur lors de l'envoi des données. Veuillez réessayer.";
            } finally {
                this.isSubmitting = false;
            }
        },
    },
} </script>
